jQuery.noConflict();     
jQuery(document).ready(function($){
    
    // if sticky header, we need to adjust the content's top spacing in case the menu grew larger
    
        var utilHeight = $('#utility-wrap').outerHeight();
        var headerHeight = $('#header-wrap').outerHeight();
        var totalTopHeight = utilHeight + headerHeight;
        
        if (totalTopHeight > 120) {
            $('#content-wrap').css('margin-top', totalTopHeight);
        }
    
    
    // hide/show search panel
    $('#util-search-link').click(function(e){
        $(this).toggleClass('active');
        $("#searchWrapper").fadeToggle();
        e.preventDefault();
    });
    
    
    $('#sortBy').each(function(){
        var select = $("<select id=sortingBy></select").insertBefore($(this).hide());

        $('.inactiveTag a').each(function(){ 
			option = $("<option></option").appendTo(select).val(this.href).html($(this).html());
		});

		$('.activeTag a').each(function(){ 
			option = $("<option selected></option").appendTo(select).val(this.href).html($(this).html());
		});

		select.change(function(){
			window.location.href = this.value;
		})
	}); 
	
    
    
        // onload fade out product details for "art" theme, they'll get shown on hover
        //$('.collectionItemDetails').fadeOut();
    
    
	$(".fader").hover(
		function () {
            var fadeTarget = this;
            if ($(".collectionItemImage",this).length > 0) {
                    fadeTarget = $(".collectionItemImage",this);
                }
			$(fadeTarget).stop().fadeTo('slow', 0.75);
            
            
                // fade in product details
                $('.collectionItemDetails', this).fadeIn('slow'); // not using .stop() on purpose
            
            
		},
		function () {
            var fadeTarget = this;
            if ($(".collectionItemImage",this).length > 0) {
                    fadeTarget = $(".collectionItemImage",this);
                }
			$(fadeTarget).stop().fadeTo('fast', 1.0);
            
            
                // fade out product details
                $('.collectionItemDetails', this).fadeOut('fast'); // not using .stop() on purpose
            
		}
	);
	
	//cache nav  
    var nav = $("#mainNav");  

    //add indicators and hovers to submenu parents  
    nav.find("li").each(function() {  
        if ($(this).find("ul").length > 0) {
            //show subnav on hover  
            $(this).mouseenter(function() {  
                $(this).find("ul").stop(true, true).fadeIn('fast');  
            });  

            //hide submenus on exit  
            $(this).mouseleave(function() {  
                $(this).find("ul").stop(true, true).fadeOut('fast');  
            });  
        }  
    })

	$("a.group").fancybox({
		'transitionIn'	:	'elastic',
		'transitionOut'	:	'elastic',
		'overlayColor'  :  '#000',
		'speedIn'		:	250, 
		'speedOut'		:	100, 
		'overlayShow'	:	true
	});

	if (navigator.userAgent.indexOf('iPhone') == -1) {
        $("#accountLinksWrapper").mouseenter(
        	function () {
        		$('#accountLink').stop(true,true).addClass('accountLinkHover');
                $('#accountLinks').stop(true,true).fadeIn();
				return false;
        	}
        );
        $("#accountLinksWrapper").mouseleave(
    		function () {
    			$('#accountLinks').stop(true,true).fadeOut();
                $('#accountLink').stop(true,true).removeClass('accountLinkHover');
				return false;
    		}
    	);
	}
    

	if (navigator.userAgent.indexOf('iPhone') != -1) {
		addEventListener("load", function() {
			setTimeout(hideURLbar, 0);
		}, false);
		$("#showNav").click(function(){
	        $('#mainNav').fadeIn();
	        return false;
	    });
	    $("#closeNavLink").click(function(){
	        $('#mainNav').fadeOut();
	        return false;
	    });
        var a = $("a").not('.group,#fancybox-close');
        for(var i=0;i<a.length;i++)
        {
            a[i].onclick=function()
            {
                window.location=this.getAttribute("href");
                return false
            }
        } 
	}  

    function hideURLbar() {
		window.scrollTo(0, 1);
	}
	

	// Detects if the current device is an Android OS-based device.	
	var deviceAndroid = "android";

	function DetectAndroid()
		 {
		    if (uagent.search(deviceAndroid) > -1)
		    $("#showNav").click(function() {
		        $('#mainNav').fadeIn();
		        return false;
		    });
		    $("#closeNavLink").click(function() {
		        $('#mainNav').fadeOut();
		        return false;
		    });
		    var a = $("a").not('.group,#fancybox-close');
		    for (var i = 0; i < a.length; i++)
		    {
		        a[i].onclick = function()
		        {
		            window.location = this.getAttribute("href");
		            return false
		        }
		    }
		} 

});